import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { SimpleListAdapter, TS_DropDown } from '@nu-art/thunderstorm-frontend/index';
import { DropDown_DefaultCaret } from '@app/styles/frontend/ui/consts';
import { findingSortMethod_LabelMap, findingSortMethods } from '@app/advisor-ui-shared';
const mandatoryProps_FindingSortMethod = {
    adapter: SimpleListAdapter([...findingSortMethods], item => _jsx(_Fragment, { children: findingSortMethod_LabelMap[item.item] })),
    caret: DropDown_DefaultCaret,
    placeholder: 'Select Finding Render Method',
};
export const DropDown_FindingSortMethod = TS_DropDown.prepare(mandatoryProps_FindingSortMethod);
//# sourceMappingURL=ui-components.js.map